import React from 'react'
import OnboardingSectionTitle from '../../../_global/OnboardingSectionTitle'
import ContactInfoForm from './Form'
import { useOnboarding } from '../../../contexts/OnboardingContext'
import { useQuery } from '@apollo/react-hooks'
import CONTACT_INFO_QUERY from '../../../apolloClient/queries/getContactInfo'
import USER_INFO_QUERY from '../../../apolloClient/queries/getUserInfo'
import Error from '../../../_global/Error'
import Loader from '../../../_global/Loader'

const ContactInfo = () => {
  const { currentExpert } = useOnboarding()

  const { loading, error, data } = useQuery(CONTACT_INFO_QUERY, {
    variables: { id: currentExpert.id },
    skip: !currentExpert.id,
  })

  const {
    loading: userLoading,
    error: userError,
    data: userData,
  } = useQuery(USER_INFO_QUERY, {
    variables: { id: currentExpert?.legacyFreelancerId },
    skip: !currentExpert,
  })

  if (loading || userLoading) return <Loader />
  if (error || userError) return <Error />

  const { id, legacyFreelancerId } = currentExpert

  const {
    getExpert: { address, personalSummary },
  } = data

  const {
    getUserInfo: { phone },
  } = userData

  const initialValues = {
    legacyFreelancerId,
    phone,
    expertId: id,
    ...address,
    ...personalSummary,
  }

  return (
    <>
      <OnboardingSectionTitle
        title="Contact Info"
        description="We are first going to get to know you a little better."
      />
      <ContactInfoForm initialValues={initialValues} />
    </>
  )
}

export default ContactInfo
